import LocalOfferOutlinedIcon from '@material-ui/icons/LocalOfferOutlined';
import CurrencyFormat from 'react-currency-format';
import styles from './CompetitorPriceValue.module.scss';

const FROM_BY_PROMOTION_TYPE = 'DE/POR';

export type CompetitorPriceValueProps = {
  retailPrice: number;
  fromPrice?: number | null;
  promotionType?: string | null;
};

export const isFromByPrice = (promotionType?: string | null, fromPrice?: number | null): boolean =>
  promotionType === FROM_BY_PROMOTION_TYPE && fromPrice !== null && fromPrice !== undefined;

const PriceAmount = ({ value }: { value: number }) => (
  <CurrencyFormat fixedDecimalScale decimalScale={2} value={value} displayType="text" prefix="R$ " decimalSeparator="," thousandSeparator="." />
);

const PriceIcon = () => <LocalOfferOutlinedIcon className={styles['competitor-price-value__icon']} data-testid="competitor-price-value-icon" />;

export const CompetitorPriceValue = ({ retailPrice, fromPrice, promotionType }: CompetitorPriceValueProps) => {
  if (!isFromByPrice(promotionType, fromPrice)) {
    return (
      <span className={styles['competitor-price-value']} data-testid="competitor-price-value-regular">
        <PriceIcon />
        <PriceAmount value={retailPrice ?? 0} />
      </span>
    );
  }

  return (
    <span className={styles['competitor-price-value']} data-testid="competitor-price-value-from-by">
      <PriceIcon />
      <span className={styles['competitor-price-value__from']}>
        De <span className={styles['competitor-price-value__from-amount']}>
          <PriceAmount value={fromPrice as number} />
        </span>
      </span>{' '}
      <span className={styles['competitor-price-value__by']}>
        <span className={styles['competitor-price-value__from']}>por</span> <PriceAmount value={retailPrice ?? 0} />
      </span>
    </span>
  );
};
